import(/* webpackMode: "eager" */ "/var/www/basic-traning-frontend/app/error.tsx");
